import { Image, StyleSheet, Text, View } from "react-native"
import Svg, { Defs, LinearGradient, Rect, Stop } from "react-native-svg"
import * as Colors from "../../../styles/colors"
import * as Fonts from "../../../styles/typography"

export default function Credencial({ numberCredential }) {
    const number = numberCredential ?
        numberCredential.toString().padStart(10, "0") :
        "0".padStart(10, "0")

    return <View>
        <Svg height="100%" width="100%" style={StyleSheet.absoluteFillObject}>
            <Defs>
                <LinearGradient id="grad" x1="100%" y1="0%" x2="100%" y2="100%">
                    <Stop offset="0" stopColor={Colors.SECONDARY} />
                    <Stop offset="1" stopColor={Colors.BLACK} />
                </LinearGradient>
            </Defs>
            <Rect width="100%" height="100%" fill="url(#grad)" rx={8} />
        </Svg>
        <View style={styles.cardView}>
            {/* <Image
                source={require("../../../../assets/images/logo-viamais.png")}
                style={styles.logoPequeno}
            /> */}
            <Text style={styles.numberText}>{number}</Text>
        </View>
    </View>
}

const styles = StyleSheet.create({
    cardView: {
        width: '100%',
        height: 200,
        justifyContent: "flex-end",
        borderRadius: 10,
        padding: 16,
        overflow: "hidden",
    },
    numberText: {
        fontSize: Fonts.FONT_SIZE_24,
        fontWeight: "700",
        letterSpacing: 2,
        color: Colors.WHITE
    },
    // logoPequeno: {
    //     resizeMode: "stretch",
    //     width: "100%",
    //     marginBottom: 8
    //   },
})